"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapInteractiveMarker = void 0;
var React = require("react");
var leaflet_1 = require("leaflet");
var react_leaflet_1 = require("react-leaflet");
var SiteMapLayerService_1 = require("../../../../services/SiteMapLayerService");
var get_marker_styles = function (color, size, icon) {
    var marker_style = "\n      background-color: ".concat(color, ";\n      width: ").concat(size, "em;\n      height: ").concat(size, "em;\n      display: block;\n      left: -").concat(size / 2, "em;\n      top: -").concat(size / 2, "em;\n      position: relative;\n      border: 1px solid #FFFFFF;\n      transform: rotate(-45deg);\n      ");
    if (icon == SiteMapLayerService_1.LayerIcon.PIN) {
        marker_style += "border-radius: ".concat(size, "em ").concat(size, "em ").concat(size, "em 0;");
    }
    if (icon == SiteMapLayerService_1.LayerIcon.CIRCLE) {
        marker_style += "border-radius: ".concat(size, "em ").concat(size, "em ").concat(size, "em ").concat(size, "em;");
    }
    return marker_style;
};
function get_location_icon(name, color, font_size, icon_size, icon_type) {
    var size = Math.round(icon_size * name.length) + 2;
    var name_styles = "\n    color: black;\n    display: block;\n    font-size: ".concat(font_size, "em;\n    font-weight: bold;\n    line-height: ").concat(size / 2, "em;\n    text-align: center;\n    transform: rotate(45deg);");
    var name_part = "<div style=\"".concat(name_styles, "\">").concat(name, "</div>");
    return new leaflet_1.DivIcon({
        iconAnchor: [0, 24],
        popupAnchor: [0, -36],
        html: "<div style=\"".concat(get_marker_styles(color, size, icon_type), "\" >").concat(name_part, "</div>"),
    });
}
function get_location_id(marker) {
    var location_str = marker.options.title;
    return parseInt(location_str.replace("location-", ""));
}
var MapInteractiveMarker = function (props) {
    var site_location = props.location;
    var markerRef = React.useRef(null);
    var markerEventHandler = {
        click: function (event) {
            var marker = markerRef.current;
            var location_id = get_location_id(marker);
            props.update_selected && props.update_selected(location_id);
        },
        dragend: function (event) {
            var marker = markerRef.current;
            if (marker != null) {
                var location_id = get_location_id(marker);
                var location_update = {
                    site_x: marker.getLatLng().lng,
                    site_y: marker.getLatLng().lat,
                };
                props.update_location &&
                    props.update_location(location_id, location_update);
                props.update_selected(location_id);
            }
        },
    };
    return (React.createElement(react_leaflet_1.Marker, { draggable: props.draggable, eventHandlers: markerEventHandler, ref: markerRef, title: "location-" + props.location.id, icon: get_location_icon(site_location.name, props.marker_style.icon_color, props.marker_style.font_size, props.marker_style.icon_size, props.marker_style.icon_type), position: [site_location.site_y, site_location.site_x] }));
};
exports.MapInteractiveMarker = MapInteractiveMarker;
